import {LitElement, svg, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {getValueOfFeature} from '../../../util/values';
import {selectSpcConfiguration} from '../../../selectors';
import {selectSolarLuminarCountValue} from '../../solarSelectors';

@customElement('svg-aeto-lightdistribution')
export class SvgAetoLightdistribution extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			width: 75%;
			height: auto;
		}

		svg {
			height: 100%;
			width: 100%;
		}

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.spcConfiguration = selectSpcConfiguration(state);
		this.translations = state.productData.translations;
		this.lang = state.status.lang;
		this.status = state.status;
		this.luminarCount = selectSolarLuminarCountValue(this.state);
		this.lightDistribution_1 = getValueOfFeature('LE_LightDistribution_1', this.spcConfiguration) ?? '';
		this.lightDistribution_2 = getValueOfFeature('LE_LightDistribution_2', this.spcConfiguration) ?? '';
	}

	render() {
		const svgPath = this.status.host + this.status.baseUrl + '/visuals/aetoLightDistribution.svg';

		return svg`
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="400" height="140" viewBox="0 0 400 140" text-rendering="geometricPrecision" shape-rendering="geometricPrecision" style="white-space: pre;">
				${when(this.luminarCount === 2, () => svg`
    				<g id="LightDistribution_2" transform="translate(343.895,57.4716) scale(0.43159,0.43159) translate(-132,-91)">
						<ellipse rx="130.829" ry="130.829" fill="#000000" stroke="#848484" stroke-width="3" transform="translate(138.252,95.7509) translate(-7.0851,-7.0851)"/>
						<use href="${svgPath}#${this.lightDistribution_2}_2"></use>
					</g>
				`)}
				<g id="LightDistribution_1" transform="translate(210.824,57.4716) scale(0.43159,0.43159) translate(-132,-91)">
        			<ellipse rx="130.829" ry="130.829" fill="#000000" stroke="#848484" stroke-width="3" transform="translate(138.252,95.7509) translate(-7.0851,-7.0851)"/>
        			<use href="${svgPath}#${this.lightDistribution_1}_1"></use>
				</g>
				<path id="line" d="M-41,0L-145,0" stroke="#313131" fill="none" stroke-linecap="square" stroke-width="2" transform="translate(62.5,56.5) translate(93,0)"/>
			</svg>
		`;
	}
}
